import { inject } from '@angular/core';
import { HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ConfirmDialogComponent, ConfirmDialogData } from '../ui/confirm-dialog/confirm-dialog';
import { CustomHeader } from '../models/header.enum';
import { ActionType } from '../../shared/models/table-column.model';
import { AppDialog } from '../services/app-dialog.service';

/** Every DELETE asks for confirmation first, unless the caller already asked (skip header). */
export const confirmDeleteInterceptor: HttpInterceptorFn = (req, next) => {
    const dialog = inject(AppDialog);
    let skipConfirmation = false;

    if (req.headers.has(CustomHeader.SkipDeleteConfirmation)) {
        req = req.clone({ headers: req.headers.delete(CustomHeader.SkipDeleteConfirmation) });
        skipConfirmation = true;
    }

    if (req.method === 'DELETE' && !skipConfirmation) {
        return dialog.open<boolean, ConfirmDialogData>(ConfirmDialogComponent, {
            data: { message: 'app.confirmDelete', action: ActionType.Delete },
            role: 'alertdialog',
            // The safe answer is focused, so a stray Enter does not delete anything.
            autoFocus: 'first-tabbable',
        })
            .afterClosed()
            .pipe(
                switchMap(confirmed => confirmed ? next(req) : new Observable<HttpEvent<unknown>>())
            );
    }

    return next(req);
}
